import lodash from 'lodash';
import { isCentralized } from './index';

/**
 * @param {Object} state Redux state
 * @param {Array<Object>} auditLogEntries 
 * @param {Array<User>} auditLogUsers 
 */
export const doaDataSelector = (state, auditLogEntries, auditLogUsers) => 
    combineDOAData({
        auditLogEntries: lodash.orderBy(auditLogEntries, ['createdAt'], ['desc']),
        auditLogUsers: auditLogUsers,
        studyTasks: lodash.get(state, 'doaStudyTasks'),
        studyRoles: lodash.get(state, 'doaRoles'),
        studyTestaments: lodash.get(state, 'doaTestaments'),
        studyDelegations: lodash.get(state, 'doaStudyDelegations'),
        studySignatures: lodash.get(state, 'doaStudySignatures'),
        isCentralized: isCentralized(state),
        studyBinder: doaStudyBinderSelector(state),
    });


/**
 * Combines all the types of DOA data along with the audit data.
 * @returns {DOA}
 */
export const combineDOAData = ({
    auditLogEntries,
    auditLogUsers,
    studyTasks,
    studyRoles,
    studyTestaments,
    studyDelegations,
    studySignatures,
    isCentralized,
    studyBinder,
}) => {
    return {
        auditLogEntries,
        auditLogUsers: keyById(auditLogUsers),
        studyTasks: keyById(studyTasks),
        studyRoles: keyById(studyRoles),
        studyTestaments: keyById(studyTestaments),
        studyDelegations: keyById(studyDelegations),
        studySignatures: keyById(studySignatures, 'signature.id'), 
        isCentralized,
        studyBinder,
    };
};

/**
 * @param {Array<Object>} values
 * @param {String} key
 */
const keyById = (values, key = 'id') => {
    if(values && lodash.isArray(values) && values.length > 0) {
        return lodash.keyBy(values, key);
    }
};

const doaStudyBinderSelector = state => lodash.pick(lodash.get(state, 'binder', {}), 
    ['title', 'primaryInvestigator', 'trialId', 'sponsorCro', 'departmentSiteDg']);